import React, { useContext, useEffect, useState } from "react";
import { Button } from "../../../../../../stories/Button/Button";
import Close from "../../../../../../images/Close.svg";
import { Title } from "../../../../../../stories/Title/Title";
import { Label } from "../../../../../../stories/Label/Label";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
import {
  handleMUISelectEvent,
  toIsoDate,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";
import { Keys } from "../../../../../../utils/Enum.keys";
import Input from "../../../../../../stories/Input/Input";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import DataFetch from "../../../../../../images/OpenIcon.svg";
import { CustomDrawer } from "../../../../../../styles/CustomDrawerStyles";
import SelectedSuppliers from "../SelectedSuppliers";
import {
  MaterialRequestStatus,
  Operation,
  TransStatus,
  YesNo,
} from "../../../../../../utils/Enum.types";
import { LabelProps, msgType } from "../../../../../../utils/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";

import { AppContext } from "../../../../../../context/context";
import MessageModal from "../../../../../../customComponents/MessageModal";
import {
  AtsMrfTrn,
  AtsMrfTrnOrderField,
  UpdateItemInMrfTrnResult,
  UpdateItemInMrfTrnVars,
} from "../queries/types";
import { GetMrfTrns, MrfTrsByNode } from "../queries/queries";
import {
  concludeFormDataType,
  concludeItemDataType,
  responseType,
} from "../../../../../../utils/formTypes";
import { Form, Formik, FormikProps } from "formik";
import { concludeFormValidation } from "../../../../../../utils/validationSchema";
import MultiSelectSupplier from "../MultiSelectSupplier";
import { UpdateItemInMrfTrn } from "../queries/mutations";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import InputNumber from "../../../../../common/Input/InputNumber";
import LoadingModal from "../../../../../pages/LoadingModal";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";
import { LdgrQueryType } from "../../../masters/supplier/queries/types";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const Conclude = ({ setModalFlag }: Props) => {
  const [selectSuppliers, setSelectSuppliers] = useState(false);
  const { PurchaseForm } = useFormJson();
  const [selectedSuppliers, setSelectedSuppliers] = useState<responseType[]>(
    []
  );
  const { user_details } = useLoggedInUserDetails();
  const { serverDate } = useServerDateandTime();
  const { customer_id, mrf_id } = useUrlParams();

  const [UpdateConclude, { loading: UpdateItemInMrfTrnLoading }] = useMutation<
    UpdateItemInMrfTrnResult,
    UpdateItemInMrfTrnVars
  >(UpdateItemInMrfTrn);

  const inputJson: LabelProps[] = [
    {
      labelName: "Accepted Qty",
      inputName: "acceptQty",
      required: true,
    },
    {
      labelName: "Requested Qty",
      inputName: "reqQty",
      disabled: true,
    },
  ];

  const initialItmData: concludeItemDataType = {
    uom_desc: "",
    uom: "",
    udfItemDesc: "",
    present_stock: "",
    required_qty: "",
    approx_rate: "",
    taxable_value: "",
    tax: "",
    net_value: "",
    priority: "",
    need_before: "",
    prefered_vendor: "",
    used_for: "",
    remark: "",
  };

  const [itmData, setItmData] = useState<concludeItemDataType>({
    uom_desc: "",
    uom: "",
    udfItemDesc: "",
    present_stock: "",
    required_qty: "",
    approx_rate: "",
    taxable_value: "",
    tax: "",
    net_value: "",
    priority: "",
    need_before: "",
    prefered_vendor: "",
    used_for: "",
    remark: "",
  });
  const initialState: concludeFormDataType = {
    acceptQty: "",
    acceptRate: "",
    acceptRemarks: "",
    acceptValue: "",
    udfItemDesc: "",
    reqQty: "",
    acceptStatus: "",
  };
  const [formData, setFormData] = useState<concludeFormDataType>(initialState);



  const { state } = useContext(AppContext);

  const [GetItemDetails, { data }] = useLazyQuery<{ node: AtsMrfTrn }, nodeVar>(
    MrfTrsByNode
  );

  const [message, setMessage] = useState<msgType>(emptyMessage);

  useEffect(() => {
    if (state.mrfTransId) {
      GetItemDetails({
        variables: {
          id: state.mrfTransId,
         
        },
      }).then(({ data }) => {
        if (data && data.node) {
          const itmData = data.node;
          setItmData({
            approx_rate: itmData.approxRate.toString(),
            need_before: toStandardDate(itmData.trnNeedBefore),
            net_value: (
              (itmData.tax / 100) *
              (itmData.reqQty * itmData.approxRate)
            ).toString(),
            prefered_vendor: itmData.preferedSupplierDetails
              .map(({ desc }) => desc)
              .join(";"),
            present_stock: itmData.presentStk.toString(),
            priority: itmData.priority.toString(),
            remark: itmData.remarks,
            required_qty: itmData.reqQty.toString(),
            udfItemDesc: itmData.udfItemDesc,
            tax: itmData.tax.toString(),
            taxable_value: itmData.taxable.toString(),
            uom: itmData.item.uomDetails.uom,
            uom_desc: itmData.item.uomDetails.uomDesc,
            used_for: itmData.usedFor,
          });
          setFormData({
            ...formData,
            reqQty: itmData.reqQty.toString(),
            acceptQty: itmData.reqQty.toString(),
            udfItemDesc: itmData.udfItemDesc,
          });
          setSelectedSuppliers(
            itmData.preferedSupplierDetails.map((supplier) => ({
              label: supplier.desc,
              value: supplier.id,
            }))
          );
        }
      });
    }
  }, [GetItemDetails, state.mrfTransId, data]);

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<concludeFormDataType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };

  const itemAcceptOptions = Object.values(YesNo);

  const handleSubmit = async () => {
    const {
      reqQty,
      acceptStatus,
      acceptRate,
      acceptQty,
      acceptValue,
      ...rest
    } = formData;
    if (
      customer_id &&
      state.ActiveFinYr &&
      mrf_id &&
      state.mrfTransId 
     
    ) {
      UpdateConclude({
        variables: {
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          mrfId: mrf_id,
          input: [
            {
              mrfTrnId: state.mrfTransId,
              preferedSupplierIds: selectedSuppliers
                .map((supp) => supp.value)
                .join(","),
              acceptStatus:
                acceptStatus === YesNo.YES
                  ? TransStatus.ACCEPTED
                  : TransStatus.REJECTED,
              acceptRate: Number(acceptRate),
              acceptQty: Number(acceptQty),
              acceptValue: Number(acceptValue),
              ...rest,
            },
          ],
          
          trnDate: toIsoDate(serverDate),
          user_details,
        },
        refetchQueries: [
          {
            query: GetMrfTrns,
            variables: {
              after: null,
              customerId: customer_id,
              finYrId: state.ActiveFinYr.id,
              first: ROWS_PER_PAGE,
              mrfId: mrf_id,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsMrfTrnOrderField.SL_NO,
              },
              name: EMPTY_STRING,
              
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.UpdateItemInMrfTrn) {
          setMessage({
            flag: true,
            message: "Updated successfully",
            operation: Operation.CREATE,
          });
        }
      });
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setModalFlag(false);
      handleClear();
    }
    setItmData(initialItmData);
    setMessage(emptyMessage);
  };
  const handleClear = () => {
    setFormData(initialState);
  };
  const { itemLabel, ledgerLabel } = useLabels();
  return (
    <>
      <Formik
        initialValues={formData}
        validationSchema={concludeFormValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form className="conclude">
              <div className="conclude__title">
                <Title>Conclude {itemLabel} Acceptance</Title>
                <img src={Close} alt="" onClick={() => setModalFlag(false)} />
              </div>
              <div className="conclude__datablock row g-0">
                <div className="col conclude__datablock--left">
                  <Title variant="subtitle1">{itemLabel} Details</Title>
                  <div className="conclude__datablock--left--frame">
                    {PurchaseForm.Conclude.map(
                      (res: LabelProps, index: React.Key) => {
                        return (
                          <React.Fragment key={index}>
                            <div className="conclude__datablock--left--grid">
                              <Label>{res.labelName}</Label>
                              <Input
                                disabled
                                name={res.inputName}
                                value={itmData[res.inputName]}
                                required={res.required}
                              />
                            </div>
                          </React.Fragment>
                        );
                      }
                    )}
                  </div>
                </div>
                <div className="col conclude__datablock--right">
                  <Title variant="subtitle1">{ledgerLabel} Conclude</Title>
                  <Label>{itemLabel} Accept Yes/No</Label>
                  <FormAutocomplete
                    className={formClasses.inputRoot}
                    options={itemAcceptOptions}
                    onKeyDown={(e) => {
                      if (e.key === Keys.ENTER) {
                        e.preventDefault();
                        handleMUISelectEvent(e);
                      }
                    }}
                    openOnFocus
                    forcePopupIcon
                    value={formData.acceptStatus}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        className={formClasses.formControlRoot}
                      />
                    )}
                    onChange={(event, newValue) => {
                      setFormData({
                        ...formData,
                        acceptStatus: newValue as YesNo,
                      });
                    }}
                  />
                  {formData.acceptStatus === YesNo.YES ? (
                    <div className="conclude__datablock--right--accepted">
                      <div className="row g-0 conclude__datablock--right--accepted--flex">
                        {inputJson.map((field: LabelProps, key: React.Key) => {
                          return (
                            <div className="col" key={key}>
                              <Label>{field.labelName}</Label>
                              <InputNumber
                                name={field.inputName}
                                value={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                disabled={field.disabled}
                                required={field.required}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        })}
                      </div>
                      <Label>Description Sent on RFQ</Label>
                      <TextArea
                        rows={3}
                        name="udfItemDesc"
                        onChange={(e) => {
                          handleValueChange(e, meta);
                        }}
                        value={formData.udfItemDesc}
                      />
                      {meta.touched["udfItemDesc"] &&
                      meta.errors["udfItemDesc"] ? (
                        <span className="nodata">
                          {meta.errors["udfItemDesc"]}
                        </span>
                      ) : null}
                      <Label>RFQ Sent for ({ledgerLabel})</Label>
                      <div className="conclude__datablock--right--flex">
                        <MultiSelectSupplier
                          autoCompleteValue={selectedSuppliers}
                          handleClear={() => {}}
                          onChange={(newValue) => {
                            setSelectedSuppliers(newValue);
                          }}
                          onKeyDown={() => {}}
                          input={{
                            itemID: 0,
                            query_type: LdgrQueryType.ALL,
                            tableLevel: undefined,
                          }}
                        />
                        <img
                          src={DataFetch}
                          alt=""
                          className="data-fetch-icon"
                          onClick={() => setSelectSuppliers(!selectSuppliers)}
                        />
                      </div>
                      <Label>Remark</Label>
                      <TextArea
                        rows={3}
                        name="acceptRemarks"
                        onChange={(e) => {
                          handleValueChange(e, meta);
                        }}
                      />
                      {meta.touched["acceptRemarks"] &&
                      meta.errors["acceptRemarks"] ? (
                        <span className="nodata">
                          {meta.errors["acceptRemarks"]}
                        </span>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
              <Button mode="save" type="submit" />
              <Button
                mode="cancel"
                type="button"
                onClick={() => setModalFlag(false)}
              />
            </Form>
          );
        }}
      </Formik>

      <CustomDrawer
        anchor="right"
        open={selectSuppliers}
        onClose={() => setSelectSuppliers(!selectSuppliers)}
      >
        <SelectedSuppliers
          setModalFlag={setSelectSuppliers}
          pageType={MaterialRequestStatus.APPROVED}
          handleClose={() => {}}
        />
      </CustomDrawer>

      <MessageModal
        value={message.message}
        modalFlag={message.flag}
        operation={message.operation}
        handleClose={handleClose}
      />
      <LoadingModal flag={UpdateItemInMrfTrnLoading} />
    </>
  );
};

export default Conclude;
